export const safeHTMLRenderer = (_instance, td, _row, _col, _prop, value) => {
  if (!value) {
    td.innerHTML = `<div class="truncated"></div>`;
    return td;
  }

  td.innerHTML = `<div class="truncated">${value}</div>`;
  return td;
};
